<!--
 * @Description: 余额清分记录
-->
<template>
  <scroll-layout>
    <template #header>
      <ykc-search
        ref="YkcSearch"
        :data="searchData"
        :searchForm="searchParams"
        confirmBtnLabel="确认"
        clearBtnLabel="清空"
        @click="handleSearchConfirm"
        @clean="handleSearchClean"></ykc-search>
    </template>
    <div class="record-page">
      <ykc-table ref="YkcTable" :data="tableData" :columns="tableColumns" title="余额清分记录">
        <template #headerButtons>
          <ykc-button type="plain" @click="doExportFile">导出</ykc-button>
        </template>
        <ykc-pagination
          slot="pagination"
          ref="YkcPagination"
          direct="flex-end"
          :total="pageInfo.total"
          :current-page.sync="pageInfo.pageIndex"
          @current-change="handlePaginationCurrentChange"
          :page-size.sync="pageInfo.pageSize"
          @size-change="handlePaginationSizeChange"></ykc-pagination>
      </ykc-table>
    </div>

    <ykc-operation-dialog
      title="发起请求"
      confirm-btn-txt="确认提交"
      :confirm-loading="confirmLoading"
      :before-confirm="handleConfirmRequest"
      :show.sync="requestDialogVisible">
      <div slot="content" class="request-dialog-content">
        <div class="request-item">
          <span class="request-label">编码：</span>
          <span class="request-value">{{ currentRow.clearScoreNo }}</span>
        </div>
        <div class="request-item">
          <span class="request-label">请求交易金额：</span>
          <span class="request-value">{{ requestAmount }}元</span>
          <span class="request-tip">（实时计算金额）</span>
        </div>
      </div>
    </ykc-operation-dialog>

    <clearing-log-dialog
      :show.sync="logDialogVisible"
      :type="1"
      :client-sn="logClientSn"></clearing-log-dialog>
  </scroll-layout>
</template>

<script>
  import YkcOperationDialog from '@/components/ykc-ui/operation-dialog';
  import ClearingLogDialog from './components/ClearingLogDialog.vue';
  import { balanceClearRecord } from '@/service/apis';
  import { offlineExport } from '@/utils';

  export default {
    name: 'BalanceClearRecord',
    components: {
      YkcOperationDialog,
      ClearingLogDialog,
    },
    data() {
      return {
        tableData: [],
        pageInfo: {
          total: 0,
          pageIndex: 1,
          pageSize: 10,
        },
        searchParams: {
          clearScoreNo: '',
          funBatchId: '',
          tradeStatus: '',
          clearDate: [],
          createdDate: [],
        },
        tradeStatusOptions: [
          { id: 1, name: '确认中' },
          { id: 2, name: '待处理' },
          { id: 3, name: '处理中' },
          { id: 4, name: '处理成功' },
          { id: 5, name: '处理失败' },
        ],
        tableColumns: [
          { label: '清分编码', prop: 'clearScoreNo', minWidth: '180px' },
          { label: '收款方', prop: 'payeeName', minWidth: '120px' },
          {
            label: '清分批次号',
            prop: 'funBatchId',
            minWidth: '150px',
            scopedSlots: {
              default: ({ row }) => this.renderFunBatchIdCell(row.funBatchId),
            },
          },
          { label: '清分金额（元）', prop: 'tradeAmount', minWidth: '130px' },
          { label: '清分状态', prop: 'tradeStatusName', minWidth: '100px' },
          {
            label: '创建人',
            prop: 'createdPersonName',
            minWidth: '100px',
            scopedSlots: {
              default: ({ row }) => {
                return <span>{row.createdPerson === 0 ? '系统' : row.createdPersonName}</span>;
              },
            },
          },
          { label: '账单日期', prop: 'clearDate', minWidth: '130px' },
          { label: '创建时间', prop: 'createdTime', minWidth: '170px' },
          { label: '最后更新人', prop: 'lastUpdatePersonName', minWidth: '100px' },
          { label: '最后更新时间', prop: 'lastUpdateTime', minWidth: '170px' },
          { label: '失败原因', prop: 'failReason', minWidth: '150px' },
          {
            label: '操作',
            prop: 'operate',
            minWidth: '165px',
            fixed: 'right',
            scopedSlots: {
              default: ({ row }) => {
                return (
                  <div class="operate-btns">
                    <ykc-button type="text" onClick={() => this.handleShowLog(row)}>
                      查看日志
                    </ykc-button>
                    {row.tradeStatus === 5 && (
                      <ykc-button type="text" onClick={() => this.handleRequest(row)}>
                        失败重试
                      </ykc-button>
                    )}
                  </div>
                );
              },
            },
          },
        ],
        requestDialogVisible: false,
        confirmLoading: false,
        currentRow: {},
        requestAmount: '0.00',
        logDialogVisible: false,
        logClientSn: '',
      };
    },
    computed: {
      searchData() {
        return [
          {
            comName: 'YkcInput',
            key: 'clearScoreNo',
            label: '清分编码',
            placeholder: '请输入',
          },
          {
            comName: 'YkcInput',
            key: 'funBatchId',
            label: '清分批次号',
            placeholder: '请输入',
          },
          {
            comName: 'YkcDropdown',
            key: 'tradeStatus',
            data: this.tradeStatusOptions,
            label: '清分状态',
            placeholder: '请选择清分状态',
          },
          {
            comName: 'YkcDatePicker',
            key: 'clearDate',
            label: '账单日期',
            type: 'daterange',
            startPlaceholder: '开始日期',
            endPlaceholder: '结束日期',
          },
          {
            comName: 'YkcDatePicker',
            key: 'createdDate',
            label: '创建时间',
            type: 'daterange',
            startPlaceholder: '开始日期',
            endPlaceholder: '结束日期',
          },
        ];
      },
    },
    created() {
      this.searchTableList();
    },
    methods: {
      /** 渲染清分批次号单元格（鼠标悬停显示复制按钮） */
      renderFunBatchIdCell(funBatchId) {
        if (!funBatchId) return '——';
        return (
          <span class="fun-batch-id-cell">
            <span class="fun-batch-id-text" title={funBatchId}>
              {funBatchId}
            </span>
            <i
              class="el-icon-document-copy fun-batch-id-copy-btn"
              title="复制"
              onClick={event => {
                event.stopPropagation();
                this.handleCopyFunBatchId(funBatchId);
              }}></i>
          </span>
        );
      },
      /** 复制清分批次号 */
      handleCopyFunBatchId(funBatchId) {
        this.$copyText(funBatchId)
          .then(() => {
            this.$message.success('复制成功');
          })
          .catch(() => {
            this.$message.error('复制失败');
          });
      },
      searchTableList() {
        const params = {
          clearScoreNo: this.searchParams.clearScoreNo,
          funBatchId: this.searchParams.funBatchId,
          tradeStatus: this.searchParams.tradeStatus,
          clearDateStart: (this.searchParams.clearDate && this.searchParams.clearDate[0]) || '',
          clearDateEnd: (this.searchParams.clearDate && this.searchParams.clearDate[1]) || '',
          createdTimeStart:
            (this.searchParams.createdDate && this.searchParams.createdDate[0]) || '',
          createdTimeEnd: (this.searchParams.createdDate && this.searchParams.createdDate[1]) || '',
          current: this.pageInfo.pageIndex,
          size: this.pageInfo.pageSize,
        };
        balanceClearRecord.list(params).then(response => {
          this.tableData = (response && response.records) || [];
          this.pageInfo.total = (response && response.total) || 0;
        });
      },
      handleSearchConfirm(form) {
        this.pageInfo.pageIndex = 1;
        Object.assign(this.searchParams, form);
        this.searchTableList();
      },
      handleSearchClean(form) {
        Object.assign(this.searchParams, form);
        this.searchParams.clearDate = [];
        this.searchParams.createdDate = [];
      },
      handlePaginationCurrentChange(current) {
        this.pageInfo.pageIndex = current;
        this.searchTableList();
      },
      handlePaginationSizeChange(size) {
        this.pageInfo.pageIndex = 1;
        this.pageInfo.pageSize = size;
        this.searchTableList();
      },
      doExportFile() {
        offlineExport(
          {
            downloadType: 'finance_export',
            jsonNode: {
              downloadKey: 'balanceClearRecordExport',
              clearScoreNo: this.searchParams.clearScoreNo,
              funBatchId: this.searchParams.funBatchId,
              tradeStatus: this.searchParams.tradeStatus,
              clearDateStart: (this.searchParams.clearDate && this.searchParams.clearDate[0]) || '',
              clearDateEnd: (this.searchParams.clearDate && this.searchParams.clearDate[1]) || '',
              createdTimeStart:
                (this.searchParams.createdDate && this.searchParams.createdDate[0]) || '',
              createdTimeEnd:
                (this.searchParams.createdDate && this.searchParams.createdDate[1]) || '',
            },
          },
          this.pageInfo.total
        );
      },
      /** 查看历史请求日志 */
      handleShowLog(row) {
        this.logClientSn = row.clearScoreNo;
        this.logDialogVisible = true;
      },
      handleRequest(row) {
        this.currentRow = row;
        this.requestAmount = '0.00';
        this.confirmLoading = false;
        balanceClearRecord.calculateAmount(row.id).then(res => {
          this.requestAmount = res || '0.00';
          this.requestDialogVisible = true;
        });
      },
      handleConfirmRequest(hide) {
        this.confirmLoading = true;
        balanceClearRecord
          .request(this.currentRow.id)
          .then(() => {
            this.$message.success('发起请求已提交');
            hide();
            this.searchTableList();
          })
          .finally(() => {
            this.confirmLoading = false;
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
  // 操作列按钮间距
  .operate-btns {
    .ykc-button + .ykc-button {
      margin-left: 16px;
    }
  }

  .record-page {
    padding: 0;

    // 清分批次号单元格：鼠标悬停显示复制按钮
    .fun-batch-id-cell {
      display: inline-flex;
      align-items: center;
      max-width: 100%;

      .fun-batch-id-text {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .fun-batch-id-copy-btn {
        flex-shrink: 0;
        margin-left: 4px;
        color: #1890ff;
        cursor: pointer;
        visibility: hidden;

        &:hover {
          color: #40a9ff;
        }
      }

      &:hover .fun-batch-id-copy-btn {
        visibility: visible;
      }
    }
  }

  .request-dialog-content {
    padding: 10px 0;

    .request-item {
      margin-bottom: 16px;
      font-size: 14px;

      .request-label {
        color: #606266;
      }

      .request-value {
        color: #303133;
        font-weight: 500;
      }

      .request-tip {
        color: #f56c6c;
      }
    }
  }
</style>
